<template>
  <div class="view match">
    <component :is="activeView" />
  </div>
</template>

<script>
export default {
  computed: {
    activeView() {
      // Get status of the Match
      const isOngoing = this.$store.state.isGameOver;
      const isOnBreak = this.$store.state.isOnBreak;


      if (!isOngoing)
        return () => import("../components/Prequiz.vue");

      if(isOnBreak) {
        console.log('g');
      }
      return () => import("../components/Quiz.vue");
    }
  }
};
</script>

<style lang="sass" scoped>
.match
  display: grid
  grid-template-rows: auto
</style>
